<template lang="pug">
  .component-login-page
    .row.login-page-container.align-middle.collapse
      .columns.hide-for-small-only.small-12.medium-6.region-left.align-self-middle
        .col-wrapper
          .branding.full
            img(:src="positiveLogo")
      .columns.small-12.small-order-1.medium-6.region-right
        .col-wrapper
          img.show-for-small-only(:src="positiveLogo")
          h1.welcome-title Login to your account
          login(@login="loginHandler")
            .login-error-message(v-if="error_message") {{ error_message }}
          p(@click="tokenLogin()") use token
</template>

<script type="text/babel">


  import Login from '../components/structure/Login'
  import KeplerBackofficeSdk from '../lib/kepler/backoffice'

  export default {
    name: 'LoginPage',
    components: {
      Login

    },
    created() {

    },
    methods: {
      tokenLogin: function () {
        var token = prompt("insert token")
        localStorage.setItem('backoffice-token', token)
        window.location.href = '/'
      },
      loginHandler: function (payload) {

        KeplerBackofficeSdk.login(payload, (response) => {
          //
          this.$store.dispatch('login', response.operator).then((user) => {
            localStorage.setItem('backoffice-token', response.api_token)
            window.location.href = '/'
          })
          //self.$router.push({name: 'home'})
        })

      }
    },
    data() {
      return {
        error_message: null
      }
    },
    computed: {
      positiveLogo: function () {
        if (window && window.env) {
          return window.env.LOGO
        }
      },
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// LoginPage.vue?450d33d5